module.exports = __webpack_public_path__ + "img/dicodingFE.2ca384af.webp";